module.exports = __webpack_public_path__ + "img/badge-silver.cd97e702.png";